import { CoachPanelProvider } from './CoachPanelProvider';
import { CoachPanelDrawer } from './CoachPanelDrawer';
import type { ReactNode } from 'react';

/**
 * Root wrapper that provides coach panel context and renders the drawer.
 * Use in App.tsx (staging only). Children get access to useCoachPanelContext().
 */
export function CoachPanelRoot({ children }: { children: ReactNode }) {
  return (
    <CoachPanelProvider>
      {children}
      <CoachPanelDrawer />
    </CoachPanelProvider>
  );
}
